import { motion } from "framer-motion";
import { Handshake, TrendingUp, Scale, PiggyBank } from "lucide-react";

const EXPERTISE_ITEMS = [
  {
    id: "courtage",
    title: "Courtage",
    description:
      "Accompagnement personnalisé dans l'achat et la vente de biens immobiliers. Estimation, mise en vente et conclusion de transactions.",
    icon: Handshake,
  },
  {
    id: "valorisation",
    title: "Valorisation",
    description:
      "Mise en valeur de patrimoine immobilier. Analyse des options, définition des objectifs et mise en œuvre de la stratégie en vue de maximiser le rendement.",
    icon: TrendingUp,
  },
  {
    id: "juridique",
    title: "Conseils juridiques",
    description:
      "Analyse juridique des transactions immobilières. Accompagnement dans les démarches légales, droits de propriété et conformité.",
    icon: Scale,
  },
  {
    id: "finance",
    title: "Conseils financier & levée de fonds",
    description:
      "Structuration financière de projets immobiliers. Montage de dossiers et levée de financement auprès d'investisseurs et établissements bancaires.",
    icon: PiggyBank,
  },
];

export default function ExpertiseSection() {
  return (
    <div
      className="py-24 md:py-32"
      data-testid="expertise-section"
      style={{ background: "rgba(5,5,5,0.85)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="section-label mb-3"
        >
          Expertises
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-3xl md:text-5xl tracking-tight font-light text-[#FAFAF8] mb-16"
          data-testid="expertise-title"
        >
          Domaines d'expertise
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {EXPERTISE_ITEMS.map(({ id, title, description, icon: Icon }, i) => (
            <motion.div
              key={id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                delay: 0.08 * i,
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -4 }}
              className="expertise-card relative glass-panel rounded-2xl p-8 cursor-default transition-all duration-500 hover:bg-white/[0.06] hover:border-white/[0.15] hover:shadow-[0_0_40px_-10px_rgba(167,199,231,0.15)] group"
              data-testid={`expertise-card-${id}`}
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#B07D62]/[0.08] border border-[#B07D62]/[0.12] flex items-center justify-center group-hover:bg-[#B07D62]/[0.12] group-hover:border-[#B07D62]/[0.2] transition-all duration-500">
                  <Icon size={20} strokeWidth={1.5} className="text-[#B07D62]" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-medium tracking-tight text-[#FAFAF8] mb-2">
                    {title}
                  </h3>
                  <p className="text-sm text-[#FAFAF8]/80 leading-relaxed">
                    {description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
